import React, { useState } from 'react';
import { apiService } from '../../services/api';
import { useMutation } from '../../hooks/useApi';
import logger from '../../utils/logger';
import { Eye, FileDown } from 'lucide-react';

function RaportStokVjeter() {
  const [ditet, setDitet] = useState(90);
  const [data, setData] = useState([]);
  const [error, setError] = useState('');

  const { mutate: fetchRaport, loading: loadingRaport } = useMutation(
    async ({ ditet }) => {
      return await apiService.get('/raport-stok-vjeter', { params: { ditet } });
    },
    {
      onSuccess: (data) => {
        setData(data?.data || []);
        setError('');
      },
      onError: () => {
        setError('Nuk mund te merret raporti.');
      },
      showNotifications: false
    }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    fetchRaport({ ditet });
  };

  const handleExportPdf = async () => {
    try {
      const response = await apiService.get('/raport-stok-vjeter/pdf', {
        params: { ditet },
        responseType: 'blob'
      });
      const file = new Blob([response], { type: 'application/pdf' });
      window.open(URL.createObjectURL(file));
    } catch (err) {
      logger.error('PDF export error:', err);
      setError('Deshtoi shkarkimi i PDF-it.');
    }
  };

  return (
    <div className="space-y-6 animate-fade-in">
      <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gradient-logo flex items-center gap-3 animate-slide-down">
        <div className="p-2 bg-primary-100 dark:bg-primary-900/30 rounded-lg">
          ⏳
        </div>
        Raport Stok i Vjeter
      </h2>

      <form onSubmit={handleSubmit} className="card-premium p-6 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="form-label">Prag dite</label>
          <input type="number" value={ditet} onChange={(e) => setDitet(Number(e.target.value))} min={1} className="input-premium" />
        </div>
        <button type="submit" className="btn-primary mt-auto">
          <Eye size={18} /> Shfaq
        </button>
        <button type="button" onClick={handleExportPdf} className="btn-primary mt-auto">
          <FileDown size={18} /> Shkarko PDF
        </button>
      </form>

      {error && <p className="form-error text-center">{error}</p>}

      {loadingRaport && (
        <div className="flex justify-center items-center py-8">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary-500 border-t-transparent"></div>
        </div>
      )}

      {data.length > 0 && (
        <div className="overflow-x-auto rounded-xl border border-gray-200 dark:border-dark-700 shadow">
          <table className="table-premium">
            <thead>
              <tr>
                <th className="p-3 text-left">Lokacioni</th>
                <th className="p-3 text-left">Produkti</th>
                <th className="p-3 text-left">Madhesia</th>
                <th className="p-3 text-left">Ngjyra</th>
                <th className="p-3 text-right">Sasia</th>
                <th className="p-3 text-right">Dite pa shitje</th>
              </tr>
            </thead>
            <tbody>
              {data.map((r, i) => (
                <tr key={i} className="border-t border-gray-200 dark:border-dark-700 hover:bg-gray-50 dark:hover:bg-dark-700/50">
                  <td className="p-3 text-gray-700 dark:text-gray-300">{r.lokacioni}</td>
                  <td className="p-3 font-medium text-gray-700 dark:text-gray-300">{r.produkti}</td>
                  <td className="p-3 text-gray-700 dark:text-gray-300">{r.madhesia}</td>
                  <td className="p-3 text-gray-700 dark:text-gray-300">{r.ngjyra}</td>
                  <td className="p-3 text-right font-semibold text-primary-600 dark:text-primary-400">{r.sasia}</td>
                  <td className="p-3 text-right font-semibold text-orange-600 dark:text-orange-400">{r.ditet_pa_shitje}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {!loadingRaport && data.length === 0 && !error && (
        <div className="empty-state">
          <p className="empty-state-title">Nuk ka stok të vjetër</p>
          <p className="empty-state-description">Të gjitha produktet janë në stok të freskët.</p>
        </div>
      )}
    </div>
  );
}

export default RaportStokVjeter;
